<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('mentora_course_registration')"
                        :is-filter="false"
                >
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('mentora_course_registration')"
                              :is-filter="false"
                >
                </HeaderMobile>
            </template>

            <div>
                <b-card class="p-5" v-if="registration && registration.student_program">
                    <b-row>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('student_id')">
                                <b-input-group>
                                    <div class="label-as-input">{{ registration.student_program.student.student_number }}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('name')">
                                <b-input-group>
                                    <div class="label-as-input">{{ registration.student_program.student.person.name }} {{registration.student_program.student.person.surname}}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('registration_type')">
                                <b-input-group>
                                    <div class="label-as-input">{{ registration.student_program.registration_type_name }}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('legal_presence_type')">
                                <b-input-group>
                                    <div class="label-as-input">{{ registration.student_program.legal_presence_type }}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('email')">
                                <b-input-group>
                                    <div class="label-as-input">{{ registration.student_program.student.person.email }}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('phone_number')">
                                <b-input-group>
                                    <div class="label-as-input">{{registration.student_program.student.person.mobile_tel_country_code}} {{ registration.student_program.student.person.mobile_tel }}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group label="Tuition and Mandatory Fees">
                                <b-input-group>
                                    <div class="label-as-input">${{parseFloat(registration.fees[0].fee)}}</div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-form-group :label="$t('course')" v-if="!registration.registered_student_sessions">
                                <multi-selectbox :multiple="false" v-model="sessionId" :options="sessions"/>
                            </b-form-group>
                            <b-form-group :label="$t('course')" v-if="registration.registered_student_sessions">
                                <multi-selectbox ref="registeredSessionSelectbox" :multiple="false" v-model="studentSessionId" :options="registeredSessions"/>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row v-if="timetables.length && studentSession && studentSession.is_paid && studentSession.is_finalized">
                        <b-col cols="12">
                            <vue-cal :selected-date="startDate"
                                     :time-cell-height="30"
                                     :time-step="60"
                                     :disable-views="['years', 'year', 'month', 'day']"
                                     active-view="week"
                                     :hide-weekdays="[]"
                                     hide-title-bar
                                     :events="timetables"
                                     locale="en"
                                     :time-from="timeFrom"
                                     :time-to="timeTo"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="registration">
                        <b-col cols="12" v-if="registration.is_active">
                            <b-button variant="primary" class="mx-auto d-block" v-if="checkPermission('studentsession_register') && sessionId && !studentSession" @click="register">
                                {{$t('register') }}
                            </b-button>
                            <b-button variant="success" class="mx-auto d-block" v-else-if="checkPermission('studentsession_createpaymentplan') && studentSession && !studentSession.is_paid" @click="$bvModal.show('selectPaymentOptionModal');">
                                {{$t('make_payment') }}
                            </b-button>
                            <b-button variant="danger" class="mx-auto d-block" v-else-if="checkPermission('studentsession_finalize') && studentSession && !studentSession.is_finalized" @click="finalize()">
                              Click Here to Complete Your Course Registration
                            </b-button>
                        </b-col>
                        <b-col cols="12" v-if="studentSession?.is_paid && studentSession?.is_finalized">
                          <div class="alert alert-success text-center">
                            Course Registration Completed
                          </div>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <CommonModal id="selectPaymentOptionModal" size="md">
                <template v-slot:CommonModalTitle>
                    <div>Payment Options</div>
                </template>
                <template v-slot:CommonModalContent>
                    <ValidationObserver ref="selectPaymentOptionForm">
                        <div class="row" v-if="registration && registration.fees.length">
                            <div class="col-12">
                                <ValidationProvider name="product_id" rules="required"
                                                    v-slot="{valid, errors}">
                                    <b-form-radio v-for="fee in registration.fees" :value="fee.id" v-bind:key="fee.id" class="mt-2" v-model="registration.product_id">{{fee.name}} - ${{fee.fee}}</b-form-radio>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mt-3">
                                <b-button type="submit" variant="success" @click="createPaymentPlan">{{$t('make_payment') }}</b-button>
                            </div>
                        </div>
                    </ValidationObserver>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
// Components
// Others
import 'vue-cal/dist/vuecal.css'
import '/src/locales/en/vuecal.js'
import StudentSessionService from "@/services/StudentSessionService";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import CustomerService from "@/services/CustomerService";
import Base from "@/plugins/Base";
import VueCal from "vue-cal";
import moment from "moment/moment";

export default {
    components: {
        VueCal,
        MultiSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t('mentora_course_registration')
        }
    },
    data() {
        return {
            studentProgramId: null,
            registration: null,
            sessionId: null,
            studentSessionId: null,
            studentSession: null,
            sessions:[],
            registeredSessions:[],
            timetables: [],
            startDate: null,
            timeFrom: null,
            timeTo: null,
            selectedEvent: {}
        }
    },

    methods: {
        getRegistration() {
            StudentSessionService.getRegistration(this.studentProgramId)
                .then(response => {
                    this.registration = response.data.data;
                    this.sessions = this.registration.sessions.map(session => {
                        return {
                            value: session.id,
                            text: session.esl_course.name + ' ' + session.start_date + ' - ' + session.end_date
                        };
                    });
                    if(this.registration.registered_student_sessions){
                      this.registeredSessions = this.registration.registered_student_sessions.map(studentSession => {
                        return {
                          value: studentSession.id,
                          student_session: studentSession,
                          text: studentSession.session.esl_course.name + ' ' + studentSession.session.start_date + ' - ' + studentSession.session.end_date
                        };
                      });
                      this.studentSession = this.registration.registered_student_sessions[0];
                      this.studentSessionId = this.studentSession.id;
                      this.setSchedule(this.studentSession.session);
                    }
                })
                .catch(error => {
                    this.showErrors(error);
                });
        },
        register(){
            if (!this.sessionId) {
                return;
            }
            StudentSessionService.registerToSession(this.studentProgramId, this.sessionId)
                .then(response => {
                    this.getRegistration();
                })
                .catch(error => {
                    this.showErrors(error);
                });
        },
        finalize(){
          if (!this.studentSessionId) {
            return;
          }
          StudentSessionService.finalize(this.studentProgramId, this.studentSessionId)
              .then(response => {
                this.getRegistration();
              })
              .catch(error => {
                this.showErrors(error);
              });
        },
        createPaymentPlan(){
            if (!this.studentSession) {
                return;
            }
            const form={
                student_program_id: this.studentProgramId,
                student_session_id: this.studentSession.id,
                product_id: this.registration.product_id,
            };
            StudentSessionService.createPaymentPlan(form)
                .then(response => {
                    this.onlinePayment();
                })
                .catch(error => {
                    this.showErrors(error);
                });
        },
        onlinePayment() {
            let data = {student_program_id: this.studentProgramId};
            CustomerService.createEpaymentLogin(data)
                .then(response => {
                    let data = response.data.data;
                    Base.LocalStorage.set('epayment_token', data.token);
                    this.setWithExpiry('epayment_redirect_after_payment', window.location.pathname);
                    this.setWithExpiry('epayment_redirect_page_name_after_payment', "Course Registration");
                    this.$store.commit('epayment/setEpaymentToken', 'Bearer ' + data.token);
                    Base.LocalStorage.set('epayment_user', data.customer);
                    this.$store.commit('epayment/setEpaymentUser', data.customer)
                    this.$router.push('/epayment');
                })
                .catch(e => {
                    this.showErrors(e);
                })
        },
        setSchedule(session){
            if(!session.schedule){
                return;
            }
            this.startDate = moment(session.start_date, "MM/DD/YYYY").format('MM/DD/YYYY');
            this.timeFrom = session.min_hour * 60;
            this.timeTo = (session.max_hour + 1) * 60;
            let timetables=[];
            session.schedule.forEach(function (item){
                timetables.push({
                    start: moment(item.date, "MM/DD/YYYY").format('MM/DD/YYYY') + ' ' + item.start_time,
                    end: moment(item.date, "MM/DD/YYYY").format('MM/DD/YYYY') + ' ' + item.end_time,
                    title: session.esl_course.name,
                    content:`${item.classroom}<br>${item.instructor}`,
                });
            });
            this.timetables=timetables;
        },
        async getFromUser() {
            let user = await this.$store.getters["auth/getUser"];
            if (
                user &&
                user.active_student_program &&
                user.active_student_program.id
            ) {
                this.studentProgramId = user.active_student_program.id??0;
            } else {
                this.$router.push("/404");
            }
        },
    },
    created() {
        this.studentProgramId = this.$route.params.studentProgramId??0;
        if(this.studentProgramId>0){
            this.getRegistration();
        }
        else {
            this.getFromUser().then(() => {
                this.getRegistration();
            });
        }
        this.startDate = moment().startOf('week').add(+1, 'days').format('MM/DD/YYYY');
    },
    watch: {
        studentSessionId: function(newVal){
            if (!newVal) {
                return;
            }
            if(this.$refs.registeredSessionSelectbox){
              let item = this.$refs.registeredSessionSelectbox.getItem(newVal);
              this.studentSession = item.student_session;
              this.setSchedule(this.studentSession.session);
            }

        }
    }
}
</script>


